import * as cx from 'classnames';
import {
    HOMEPAGE_POST_TYPE_ARTICLE,
    HOMEPAGE_POST_TYPE_CONTEST,
    HOMEPAGE_POST_TYPE_COUNSELLING,
    HOMEPAGE_POST_TYPE_COUNSELLING_TOPIC,
    HOMEPAGE_POST_TYPE_DISCUSSION,
    HOMEPAGE_POST_TYPE_EXPERIENCE,
    HOMEPAGE_POST_TYPE_FORUM_TOPIC,
    HOMEPAGE_POST_TYPE_FROM_INTERNET,
    HOMEPAGE_POST_TYPE_PHOTOBLOG_ALBUM,
    HOMEPAGE_POST_TYPE_PHOTOBLOG_ARTICLE,
    HOMEPAGE_POST_TYPE_REVIEW,
    HOMEPAGE_POST_TYPE_SHORT_MESSAGE,
} from 'mk/autogenerated/translations/Post.1846ca2c24a147525aa47ec009c60bfb'
import { photoUrl } from 'mk/photo/photoUrl';
import { HomePostEntity, HomePostType } from 'mk2/apps/home/schemas';
import Img from 'mk2/components/Img';
import Link from 'mk2/components/Link';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import { getDomain } from 'mk2/helpers/urls';
import * as React from 'react';
import styles from './Post.mscss';

interface HeadingOwnProps {
    post: HomePostEntity;
}

const PostHeading: React.FunctionComponent<HeadingOwnProps> = ({ post }) => (
    <>
        <div className={styles.Post__typeAndStats}>
            <div className={styles.Post__type}>
                {typeTranslations[post.type]}
                &nbsp;
                {post.type === HomePostType.FROM_INTERNET && <span>{getDomain(post.url)}</span>}
            </div>
            <div className={styles.Post__stats}>
                {post.likes > 0 && (
                    <span className={styles.Post__stat}>
                        {post.likes}{' '}
                        <i className={cx('fa fa-thumbs-o-up')} />
                    </span>
                )}
                {post.comments > 0 && (
                    <span className={styles.Post__stat}>
                        {post.comments}{' '}
                        <i className={cx('fa fa-comment-o')} />
                    </span>
                )}
            </div>
        </div>
        <h2 className={styles.Post__title}>
            {post.title}
            &nbsp;
            {post.type === HomePostType.FROM_INTERNET && <i className="fa fa-external-link" />}
        </h2>
    </>
);

PostHeading.displayName = 'PostHeading';

interface OwnProps {
    className?: string;
    style?: React.CSSProperties;
    post: HomePostEntity;
    mobile: boolean;

    onClick?(event: React.MouseEvent<HTMLAnchorElement>);
}

type Props = OwnProps;

const typeTranslations = {
    [HomePostType.WIKI_ARTICLE]: HOMEPAGE_POST_TYPE_ARTICLE,
    [HomePostType.SHORT_MESSAGE]: HOMEPAGE_POST_TYPE_SHORT_MESSAGE,
    [HomePostType.DISCUSSION]: HOMEPAGE_POST_TYPE_DISCUSSION,
    [HomePostType.EXPERIENCE]: HOMEPAGE_POST_TYPE_EXPERIENCE,
    [HomePostType.REVIEW]: HOMEPAGE_POST_TYPE_REVIEW,
    [HomePostType.COUNSELLING]: HOMEPAGE_POST_TYPE_COUNSELLING,
    [HomePostType.COUNSELLING_TOPIC]: HOMEPAGE_POST_TYPE_COUNSELLING_TOPIC,
    [HomePostType.FORUM_TOPIC]: HOMEPAGE_POST_TYPE_FORUM_TOPIC,
    [HomePostType.FROM_INTERNET]: HOMEPAGE_POST_TYPE_FROM_INTERNET,
    [HomePostType.PHOTOBLOG_ALBUM]: HOMEPAGE_POST_TYPE_PHOTOBLOG_ALBUM,
    [HomePostType.PHOTOBLOG_ARTICLE]: HOMEPAGE_POST_TYPE_PHOTOBLOG_ARTICLE,
    [HomePostType.CONTEST]: HOMEPAGE_POST_TYPE_CONTEST,
};

const Post: React.FunctionComponent<Props> = ({ className, post, style, mobile }) => (
    <Link
        to={post.url}
        className={cx(styles.Post, mobile && styles[`Post--bottomBorder`], className)}
        style={style}
        target={post.type === HomePostType.FROM_INTERNET ? '_blank' : undefined}
    >
        {mobile && (
            <PostHeading post={post} />
        )}
        <div className={styles.Post__content}>
            <div className={styles.Post__image}>
                <Img className={styles.Post__image__img} src={photoUrl(post.photo, 'c300x300')} width={mobile ? 80 : 110} height={mobile ? 80 : 110} />
            </div>
            <div key={post.id} className={styles.Post__rightColumn}>
                {!mobile && (
                    <PostHeading post={post} />
                )}
                <div className={styles.Post__description}>{post.description}</div>
            </div>
        </div>
    </Link>
);

Post.displayName = 'Post';

export default Post;

interface PlaceholderOwnProps {
    className?: string;
    style?: React.CSSProperties;
    mobile: boolean;
}

export const PostPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({ className, style, mobile }) => (
   <div
        className={cx(styles.Post, mobile && styles[`Post--bottomBorder`], className)}
        style={style}
   >
        {mobile && (
            <>
                <div className={styles.Post__type}>
                    <LoadingPlaceholder width={80} height={18} />
                </div>
                <span className={styles.Post__title}>
                    <LoadingPlaceholder width={200} height={18} />
                </span>
            </>
        )}
        <div className={styles.Post__content}>
            <div className={styles.Post__image}>
                <LoadingPlaceholder width={mobile ? 80 : 110} height={mobile ? 80 : 110}  />
            </div>
            <div className={styles.Post__rightColumn}>
                {!mobile && (
                    <>
                        <div className={styles.Post__type}>
                            <LoadingPlaceholder width={80} height={18} />
                        </div>
                        <span className={styles.Post__title}>
                            <LoadingPlaceholder width={200} height={18} />
                        </span>
                    </>
                )}
                <div className={styles.Post__description}><LoadingPlaceholder width={mobile ? 200 : 400} height={18} /></div>
            </div>
        </div>
   </div>
);
